/**
 * @generated SignedSource<<91ec04d8229a3f02ad2dea38c8f83d2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "walletId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoTopupActive",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initialBalanceAmount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rAutoTopupAmount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rAutoTopupThreshold",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rMaxCharge",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rMaxMonthlyBudget",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestedBudgetWalletUnsetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWalletTPayload",
        "kind": "LinkedField",
        "name": "updateWalletTByWalletId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletT",
            "kind": "LinkedField",
            "name": "walletT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestedBudgetWalletUnsetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWalletTPayload",
        "kind": "LinkedField",
        "name": "updateWalletTByWalletId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletT",
            "kind": "LinkedField",
            "name": "walletT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3141dd53de0f00a2f87f355b3a4c040e",
    "id": null,
    "metadata": {},
    "name": "RequestedBudgetWalletUnsetMutation",
    "operationKind": "mutation",
    "text": "mutation RequestedBudgetWalletUnsetMutation(\n  $input: UpdateWalletTByWalletIdInput!\n) {\n  updateWalletTByWalletId(input: $input) {\n    walletT {\n      walletId\n      autoTopupActive\n      initialBalanceAmount\n      rAutoTopupAmount\n      rAutoTopupThreshold\n      rMaxCharge\n      rMaxMonthlyBudget\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6bd252a9121f15f0c1b5331349de7c1d";

module.exports = node;
